import base from "../baseurl";
import token from "../getTk";

const showAll = async (campaignId) => {
  console.log("detalles de la campana");
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const show = await api
    .post("company-form-campaigns/show", {
      json: { campaignId },
    })
    .json();
  return show;
};

export default showAll;
